import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const MessagingSection = ({ messages, onSendMessage }) => {
  const [newMessage, setNewMessage] = useState('');
  const [isClientVisible, setIsClientVisible] = useState(true);
  const [isSending, setIsSending] = useState(false);

  const handleSendMessage = async () => {
    if (!newMessage?.trim()) return;
    
    setIsSending(true);
    await onSendMessage({
      content: newMessage,
      isClientVisible,
      timestamp: new Date()?.toISOString()
    });
    setNewMessage('');
    setIsSending(false);
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date?.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="MessageSquare" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-lg font-semibold text-foreground">Messages et notes</h2>
      </div>
      <div className="space-y-4">
        <div className="bg-muted/50 rounded-lg p-4 max-h-96 overflow-y-auto space-y-3">
          {messages?.length === 0 ? (
            <div className="text-center py-8">
              <Icon name="MessageCircle" size={48} className="text-muted-foreground mx-auto mb-3 opacity-50" />
              <p className="text-sm text-muted-foreground">Aucun message pour le moment</p>
            </div>
          ) : (
            messages?.map((message, index) => (
              <div
                key={index}
                className={`p-4 rounded-lg border ${
                  message?.isClientVisible
                    ? 'bg-primary/5 border-primary/20' :'bg-warning/5 border-warning/20'
                }`}
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center space-x-2">
                    <Icon
                      name={message?.isClientVisible ? 'Eye' : 'EyeOff'}
                      size={16}
                      className={message?.isClientVisible ? 'text-primary' : 'text-warning'}
                    />
                    <span className={`text-xs font-medium ${
                      message?.isClientVisible ? 'text-primary' : 'text-warning'
                    }`}>
                      {message?.isClientVisible ? 'Visible client' : 'Note interne'}
                    </span>
                  </div>
                  <span className="text-xs text-muted-foreground">
                    {formatTimestamp(message?.timestamp)}
                  </span>
                </div>
                <p className="text-sm text-foreground">{message?.content}</p>
              </div>
            ))
          )}
        </div>
        
        <div className="space-y-3">
          <Input
            label="Nouveau message"
            type="text"
            placeholder="Entrez votre message ou note..."
            value={newMessage}
            onChange={(e) => setNewMessage(e?.target?.value)}
            description="Ajoutez un message pour le client ou une note interne"
          />
          
          <Checkbox
            label="Visible par le client"
            description="Décochez pour créer une note interne uniquement"
            checked={isClientVisible}
            onChange={(e) => setIsClientVisible(e?.target?.checked)}
          />
          
          <Button
            variant="default"
            fullWidth
            iconName="Send"
            iconPosition="left"
            loading={isSending}
            onClick={handleSendMessage}
            disabled={!newMessage?.trim()}
          >
            Envoyer le message
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MessagingSection;